import React, {useState, useContext, useEffect} from 'react';
import getGuidanceText from './getGuidanceText';
import {Context} from '../../context';

import MigrationHeader from './MigrationHeader';
import EnterCredentials from './EnterCredentials';
import SecurityQuestion from './SecurityQuestion';
import ReviewInfoAndConfirm from './ReviewInfoAndConfirm';
import MigrationSuccessful from './MigrationSuccessful';

function Migration() {
  const {localeText, locale, signOut} = useContext(Context);
  const [phase, setPhase] = useState('');
  const [guidanceText, setGuidanceText] = useState('');
  const [accessRequestId, setAccessRequestId] = useState(null);
  const [securityQuestionPassed, setSecurityQuestionPassed] = useState(false);
  const [transitionComplete, setTransitionComplete] = useState(false);
  const [accountLockedAfterTransfer, setAccountLockedAfterTransfer] =
    useState(false);

  const handleErrors = (res, setErrors) => {
    if (res.errors) {
      setErrors(() =>
        res.errors.map(error => {
          if (error.code === 'denied-account-locked') {
            signOut();
          }
          return {
            slug: error.error.slug,
            default: error.code
          };
        })
      );
    }
  };

  const props = {
    accessRequestId,
    setAccessRequestId,
    securityQuestionPassed,
    setSecurityQuestionPassed,
    transitionComplete,
    setTransitionComplete,
    accountLockedAfterTransfer,
    setAccountLockedAfterTransfer,
    handleErrors
  };

  useEffect(() => {
    const currentPhase = transitionComplete
      ? 'transition_complete' // phase 4 - Transition Complete
      : securityQuestionPassed
      ? 'review_confirm_info' // phase 3 - Confirm Transition Data is Correct
      : accessRequestId
      ? 'security_question' //   phase 2 - Ask Security Question
      : 'enter_credentials'; //  phase 1 - Enter Credentials

    setPhase(currentPhase);
    setGuidanceText(getGuidanceText(localeText, currentPhase));
  }, [accessRequestId, securityQuestionPassed, transitionComplete, locale]);

  return (
    <div
      id='section-migration'
      className='w-full h-full pt-5 flex flex-col items-center'
    >
      <MigrationHeader guidanceText={guidanceText} />
      {phase === 'enter_credentials' && <EnterCredentials {...props} />}
      {phase === 'security_question' && <SecurityQuestion {...props} />}
      {phase === 'review_confirm_info' && <ReviewInfoAndConfirm {...props} />}
      {phase === 'transition_complete' && <MigrationSuccessful {...props} />}
    </div>
  );
}

export default Migration;
